module.exports = __webpack_public_path__ + "img/taiwanese.5967a9b9.svg";